import React from 'react';
import { motion } from 'framer-motion';
import { HERO_STATS, CIRCUIT_NODES, CIRCUIT_TRACES, CIRCUIT_VIEWBOX, CIRCUIT_CENTER } from '../data/catalog';

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const Hero = () => (
  <header className="hero" id="home">
    <div className="wrap hero-grid">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <div className="eyebrow"><span className="dot" /> Cloud &amp; Enterprise Modernization Consulting</div>
        <h1>
          Modernize application, data &amp; infrastructure &mdash;{' '}
          <em>built, automated and secured end to end.</em>
        </h1>
        <p className="lede">
          JbnWorks brings enterprise expertise to application, data, and infrastructure modernization
          &mdash; handling and having handled large enterprise and government organizations on Azure,
          AWS and Google Cloud, automated, zero-trust, and delivered through disciplined engineering practice.
        </p>
        <div className="hero-actions">
          <button className="btn btn-primary" onClick={() => scrollTo('services')}>Explore the Service Catalog</button>
          <button className="btn btn-ghost" onClick={() => scrollTo('expertise')}>See Company Credentials</button>
        </div>
        <div className="hero-stats">
          {HERO_STATS.map((s) => (
            <div key={s.lbl}>
              <div className="num">{s.num}</div>
              <div className="lbl">{s.lbl}</div>
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div
        className="circuit-wrap"
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.15 }}
      >
        <svg id="circuitSvg" viewBox={CIRCUIT_VIEWBOX} xmlns="http://www.w3.org/2000/svg">
          <g className="traces">
            {CIRCUIT_TRACES.map((d) => <path key={d} className="trace-line" d={d} />)}
            <circle className="trace-joint" cx={CIRCUIT_CENTER.cx} cy={CIRCUIT_CENTER.cy} r="4" />
          </g>
          <g fill="none" stroke="#E4C77E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" transform={`translate(${CIRCUIT_CENTER.cx - 18},${CIRCUIT_CENTER.cy - 23})`} opacity="0.9">
            <path d="M6 20 C6 6, 14 -2, 18 -2 C22 -2, 30 6, 30 18 C30 26, 26 30, 24 34 L12 34 C10 30, 6 28, 6 20 Z" />
            <path d="M12 40 L24 40" />
            <path d="M14 46 L22 46" />
          </g>
          {CIRCUIT_NODES.map((n) => (
            <g
              key={n.label}
              className="node-group"
              role="button"
              tabIndex={0}
              onClick={() => scrollTo('services')}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && scrollTo('services')}
            >
              <circle className="node-circle" cx={n.cx} cy={n.cy} r="30" />
              <text className="node-label" x={n.lx} y={n.ly} textAnchor={n.anchor}>{n.label}</text>
              <text className="node-sub" x={n.cx} y={n.cy + 6} textAnchor="middle">{n.sub}</text>
            </g>
          ))}
        </svg>
        <div className="circuit-caption">
          Click a node to jump to the catalog &mdash; eight connected capabilities, one delivery pipeline
        </div>
      </motion.div>
    </div>
  </header>
);

export default Hero;
